import { useCallback, useState } from "react";
import { Message, Pagination } from "../../../BP2Components";
import { useListBuilder } from "../../../../context/ListBuilderContext/ListBuilderContext";
import ListBuilderItem from "./ListBuilderItem";
import { Button } from "antd";
import IntlMessages from "../../../../util/IntlMessages";
import ListBuilderTable from "./ListBuilderTable";
import { useIntl } from "react-intl";
import CreateNewListModal from "./ListBuilderModals/CreateNewListModal";

interface ListBuilderViewInterface {}

const ListBuilderView: React.FC<ListBuilderViewInterface> = ({}) => {
   const [isCreateNewModalOpen, setIsCreateNewModalOpen] = useState<boolean>(false);
   const [newlyCreatedList, setNewlyCreatedList] = useState<any>(null);

   const { mainList, page, setPage, setSearchData } = useListBuilder();

   const onPaginationChange = useCallback((e) => {
      if (e === 0) return;
      setPage(e);
   }, []);
   const handleNewlyCreatedList = useCallback(() => {
      setSearchData({ column: "listId", userInput: newlyCreatedList?.id });
   }, [newlyCreatedList]);

   return (
      <div className="list-builder-view">
         <div className="list-builder-top-bar">
            <div className="add-new-list-button">
               <Button
                  onClick={() => {
                     setIsCreateNewModalOpen(true);
                  }}
                  style={{ color: "black", fontSize: "11px" }}
                  type="primary"
               >
                  +&nbsp;
                  <IntlMessages id="listBuilder.create-new-list" />
               </Button>
               {newlyCreatedList && (
                  <Button onClick={handleNewlyCreatedList}>show me just created list</Button>
               )}
            </div>
         </div>
         <div className="list-builder-body">
            <ListBuilderTable data={mainList} />
         </div>
         <div className="list-builder-footer">
            <Pagination
               initialPage={page}
               defaultPageSize={8}
               totalItems={mainList?.total}
               onChange={onPaginationChange}
            />
         </div>
         <CreateNewListModal
            setNewlyCreatedList={setNewlyCreatedList}
            setIsOpen={setIsCreateNewModalOpen}
            isOpen={isCreateNewModalOpen}
         />
      </div>
   );
};

export default ListBuilderView;
